
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/classes",
      function () {
        return require("private-next-pages/account/classes/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/classes"])
      });
    }
  